import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import { Progress as BaseProgress } from "@base-ui/react/progress";
import shared from "../../shared.module.css";
import { sizeOf } from "../../utils/propTypes";
import css from "./Progress.module.css";

const CIRCUMFERENCE = 2 * Math.PI * 20; // ~125.66

const Progress = React.forwardRef(
  (
    {
      value = null,
      variant = "linear",
      size = "md",
      label,
      showValue = false,
      className,
      ...rest
    },
    ref,
  ) => {
    const isCircular = variant === "circular";
    const offset =
      value != null ? CIRCUMFERENCE - (value / 100) * CIRCUMFERENCE : 0;

    return (
      <BaseProgress.Root
        ref={ref}
        value={value}
        className={clsx(css.root, className)}
        {...rest}
      >
        <BaseProgress.Label className={shared.visuallyHidden}>
          {label}
        </BaseProgress.Label>

        {isCircular ? (
          <div className={clsx(css.circular, css[size])}>
            <svg viewBox="0 0 44 44" className={css.circularSvg}>
              <circle cx="22" cy="22" r="20" className={css.circularTrack} />
              <circle
                cx="22"
                cy="22"
                r="20"
                className={css.circularIndicator}
                strokeDasharray={CIRCUMFERENCE}
                strokeDashoffset={value != null ? offset : undefined}
              />
            </svg>
            {showValue && value != null && (
              <span className={css.circularValue}>{Math.round(value)}%</span>
            )}
          </div>
        ) : (
          <>
            <BaseProgress.Track className={css.track}>
              <BaseProgress.Indicator className={css.indicator} />
            </BaseProgress.Track>
            {showValue && value != null && (
              <span className={css.value}>{Math.round(value)}%</span>
            )}
          </>
        )}
      </BaseProgress.Root>
    );
  },
);

Progress.displayName = "Progress";

Progress.propTypes = {
  value: PropTypes.number,
  variant: PropTypes.oneOf(["linear", "circular"]),
  size: sizeOf("sm", "md", "lg"),
  label: PropTypes.string.isRequired,
  showValue: PropTypes.bool,
  className: PropTypes.string,
};

export default Progress;
